class PdpMain extends HTMLElement {
  constructor() {
    super();
    const firstFreq = this.querySelector("[data-freq]");
    this.state = {
      activeGallery: 0,
      mode: this.dataset.defaultMode === "subscribe" ? "subscribe" : "one-time",
      activePlanId: firstFreq ? firstFreq.dataset.planId || "" : "",
      activePlanPrice: firstFreq
        ? parseFloat(firstFreq.dataset.planPrice || "0") / 100
        : 0,
      subQty: 1,
      qty: 1,
    };
    this.basePrice = parseFloat(this.dataset.basePrice || "0");
    this.currencySymbol = this.dataset.currencySymbol || "€";
    this.labels = {
      add: this.dataset.labelAdd || "Añadir al carrito",
      subscribe: this.dataset.labelSubscribe || "Activar suscripción",
      soldOut: this.dataset.labelSoldout || "Agotado",
      unavailable: this.dataset.labelUnavailable || "No disponible",
    };
    this.init();
  }

  init() {
    this.bindLightbox();
    this.bindVariants();
    this.bindMode();
    this.bindFreq();
    this.bindStepper();
    this.bindForm();
    this.bindGrind();
    this.bindSheet();
    // Si la ficha arranca en suscripción (cafés), el plan ya va en el form.
    this.syncSellingPlanInput();
    this.updateAvailability();
    this.syncRoast();
    this.render();
  }

  bindLightbox() {
    this.galleryMq = window.matchMedia("(max-width: 960px)");
    const cells = this.querySelectorAll("[data-lightbox-trigger]");
    cells.forEach((cell) => {
      cell.addEventListener("click", (e) => {
        e.preventDefault();
        // En móvil, tocar una miniatura cambia la imagen principal (no abre el lightbox).
        if (cell.hasAttribute("data-gallery-thumb") && this.galleryMq.matches) {
          this.setGalleryStage(cell);
          return;
        }
        // Sin fuente que abrir no hay lightbox: es el render del producto.
        if (cell.classList.contains("is-static")) return;
        const src =
          cell.dataset.lightboxSrc ||
          (cell.querySelector("img") &&
            (cell.querySelector("img").currentSrc ||
              cell.querySelector("img").src));
        if (!src) return;
        const img = cell.querySelector("img");
        const alt = img ? img.alt || "" : "";
        this.openLightbox(src, alt);
      });
    });
  }

  // Móvil: pone la imagen de la miniatura tocada como imagen principal del escenario.
  setGalleryStage(thumb) {
    const stage = this.querySelector("[data-gallery-stage]");
    if (!stage) return;
    const stageImg = stage.querySelector("[data-gallery-stage-img]");
    const thumbImg = thumb.querySelector("img");
    if (stageImg && thumbImg) {
      stageImg.src = thumbImg.currentSrc || thumbImg.src;
      stageImg.alt = thumbImg.alt || "";
    }
    // El lightbox del escenario debe abrir la imagen activa en alta resolución.
    // Y la promesa sigue a la imagen: el render no abre nada, así que cuando el
    // escenario lo muestra pierde el cursor de zoom y el icono de expandir.
    if (thumb.dataset.lightboxSrc) {
      stage.dataset.lightboxSrc = thumb.dataset.lightboxSrc;
      stage.classList.remove("is-static");
    } else {
      delete stage.dataset.lightboxSrc;
      stage.classList.add("is-static");
    }
    this.querySelectorAll("[data-gallery-thumb]").forEach((t) =>
      t.classList.remove("is-active")
    );
    thumb.classList.add("is-active");
  }

  openLightbox(src, alt) {
    let lightbox = document.querySelector(".pdp-lightbox");
    if (!lightbox) {
      lightbox = document.createElement("div");
      lightbox.className = "pdp-lightbox";
      lightbox.innerHTML = `
        <button class="pdp-lightbox__close" type="button" aria-label="Cerrar">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <img class="pdp-lightbox__img" alt="">
      `;
      document.body.appendChild(lightbox);
      lightbox.addEventListener("click", (e) => {
        if (
          e.target === lightbox ||
          e.target.closest(".pdp-lightbox__close")
        ) {
          lightbox.classList.remove("is-open");
          document.body.style.overflow = "";
        }
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          lightbox.classList.remove("is-open");
          document.body.style.overflow = "";
        }
      });
    }
    const img = lightbox.querySelector(".pdp-lightbox__img");
    // Replace small width param with larger one for lightbox
    img.src = src.replace(/width=\d+/, "width=2400");
    img.alt = alt;
    lightbox.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  bindVariants() {
    this.querySelectorAll("[data-variant-pill]").forEach((pill) => {
      pill.addEventListener("click", (e) => {
        e.preventDefault();
        const optionGroup = pill.closest("[data-option-group]");
        if (!optionGroup) return;
        optionGroup.querySelectorAll("[data-variant-pill]").forEach((p) => {
          p.classList.remove("is-selected");
          if (p.getAttribute("role") === "radio")
            p.setAttribute("aria-checked", "false");
        });
        pill.classList.add("is-selected");
        if (pill.getAttribute("role") === "radio")
          pill.setAttribute("aria-checked", "true");
        const valueLabel = optionGroup.querySelector("[data-variant-value]");
        if (valueLabel) valueLabel.textContent = pill.dataset.optionValue;
        this.syncVariant();
      });
    });
  }

  // Variantes del producto (se parsean una sola vez).
  getVariants() {
    if (this.variantsCache) return this.variantsCache;
    const variantsScript = this.querySelector("[data-variants-json]");
    if (!variantsScript) return (this.variantsCache = []);
    try {
      this.variantsCache = JSON.parse(variantsScript.textContent) || [];
    } catch (e) {
      this.variantsCache = [];
    }
    return this.variantsCache;
  }

  // Variante que se enviaría al carrito ahora mismo.
  getCurrentVariant() {
    const input = this.querySelector('input[name="id"]');
    if (!input) return null;
    const id = String(input.value);
    return this.getVariants().find((v) => String(v.id) === id) || null;
  }

  atcLabelText() {
    const variant = this.getCurrentVariant();
    if (!variant) return this.labels.unavailable;
    if (!variant.available) return this.labels.soldOut;
    // El texto no cambia con la suscripción: el precio del botón ya lo refleja.
    return this.labels.add;
  }

  // Refleja el stock real de la variante seleccionada en el CTA y en la barra
  // sticky. Shopify rechaza el /cart/add sin stock, así que el botón no debe
  // ofrecerse como comprable.
  updateAvailability() {
    const variant = this.getCurrentVariant();
    const available = !!(variant && variant.available);
    const btn = this.querySelector("[data-atc-btn]");
    if (btn) {
      btn.disabled = !available;
      btn.classList.toggle("is-soldout", !available);
    }
    const stepper = this.querySelector("[data-stepper]");
    if (stepper) stepper.classList.toggle("is-disabled", !available);
    const sticky = document.querySelector("[data-sticky-atc]");
    if (sticky) {
      sticky.disabled = !available;
      sticky.classList.toggle("is-soldout", !available);
      const stickyLabel = sticky.querySelector("[data-sticky-atc-label]");
      if (stickyLabel) {
        if (this.stickyLabelText == null) {
          this.stickyLabelText = available
            ? stickyLabel.textContent.trim()
            : this.labels.add;
        }
        stickyLabel.textContent = available
          ? this.stickyLabelText
          : this.labels.soldOut;
      }
    }
  }

  syncVariant() {
    const selectedOptions = Array.from(
      this.querySelectorAll("[data-option-group]")
    ).map((g) => {
      const selected = g.querySelector(".is-selected");
      return selected ? selected.dataset.optionValue : null;
    });
    const variants = this.getVariants();
    if (!variants.length) return;
    const match = variants.find((v) =>
      v.options.every(
        (o, i) => selectedOptions[i] === o || selectedOptions[i] == null
      )
    );
    if (!match) return;
    this.basePrice = match.price / 100;
    const input = this.querySelector('input[name="id"]');
    if (input) input.value = match.id;

    // Refresh selling plan allocations for this variant.
    this.syncPlansForVariant(match);
    this.updateAvailability();
    this.syncRoast();
    this.syncFormatPrices(selectedOptions);
    this.render();
  }

  // Tueste elegido ('filtro' | 'espresso'), o null si la ficha no lo destaca.
  selectedRoast() {
    const group = this.querySelector("[data-roast-group]");
    if (!group) return null;
    const sel = group.querySelector(".is-selected[data-roast]");
    return sel ? sel.dataset.roast : null;
  }

  // Molienda: "En grano" o "Molido" y, si es molido, el tipo. Se guarda en
  // la propiedad de línea del formulario (properties[Molienda]).
  bindGrind() {
    const box = this.querySelector("[data-grind]");
    if (!box) return;
    this.grindMode = "grano";
    box.querySelectorAll("[data-grind-mode]").forEach((btn) => {
      btn.addEventListener("click", () => {
        this.grindMode = btn.dataset.grindMode;
        box.querySelectorAll("[data-grind-mode]").forEach((b) => {
          const on = b === btn;
          b.classList.toggle("is-selected", on);
          b.setAttribute("aria-checked", on ? "true" : "false");
        });
        this.syncRoast();
      });
    });
    box.querySelectorAll("[data-grind-type]").forEach((pill) => {
      pill.addEventListener("click", () => {
        pill.parentElement.querySelectorAll("[data-grind-type]").forEach((p) => {
          const on = p === pill;
          p.classList.toggle("is-selected", on);
          p.setAttribute("aria-checked", on ? "true" : "false");
        });
        this.syncRoast();
      });
    });
  }

  // Hoja de opciones (barra flotante). No duplica los controles: mueve el
  // contenedor [data-buybox] dentro de la hoja y lo devuelve al cerrar, así
  // la página y la hoja comparten estado, formulario y listeners.
  bindSheet() {
    this.sheet = this.querySelector("[data-buysheet]");
    this.buybox = this.querySelector("[data-buybox]");
    if (!this.sheet || !this.buybox) return;
    this.sheet.querySelectorAll("[data-buysheet-close]").forEach((el) =>
      el.addEventListener("click", () => this.closeSheet())
    );
    const atc = this.sheet.querySelector("[data-buysheet-atc]");
    if (atc)
      atc.addEventListener("click", () => {
        const form = this.querySelector("form[data-pdp-form]");
        this.closeSheet();
        if (form) form.requestSubmit();
      });
    this.onSheetKey = (e) => {
      if (e.key === "Escape") this.closeSheet();
    };
  }

  openSheet() {
    if (!this.sheet || !this.buybox || this.sheetOpen) return;
    this.sheetOpen = true;
    this.buyboxHome = document.createComment("buybox");
    this.buybox.before(this.buyboxHome);
    this.sheet.querySelector("[data-buysheet-slot]").appendChild(this.buybox);
    this.sheet.hidden = false;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.onSheetKey);
    requestAnimationFrame(() => this.sheet.classList.add("is-open"));
    const close = this.sheet.querySelector(".buysheet__close");
    if (close) close.focus();
    this.render();
  }

  closeSheet() {
    if (!this.sheetOpen) return;
    this.sheetOpen = false;
    this.sheet.classList.remove("is-open");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.onSheetKey);
    if (this.buyboxHome) {
      this.buyboxHome.replaceWith(this.buybox);
      this.buyboxHome = null;
    }
    setTimeout(() => {
      if (!this.sheetOpen) this.sheet.hidden = true;
    }, 220);
    const opener = document.querySelector("[data-sticky-open]");
    if (opener) opener.focus();
  }

  // Resumen corto de lo elegido para la barra flotante: "En grano · 250 g."
  stickySummaryText() {
    const parts = [];
    const roastGroup = this.querySelector("[data-roast-group]");
    const roastSel = roastGroup && roastGroup.querySelector(".is-selected[data-roast]");
    if (roastGroup && roastGroup.querySelectorAll("[data-roast]").length > 1 && roastSel)
      parts.push(roastSel.dataset.optionValue);
    const grind = this.querySelector("[data-grind-input]");
    if (grind) parts.push(grind.value);
    const fmtSel = this.querySelector("[data-format-group] .is-selected");
    if (fmtSel) parts.push(fmtSel.dataset.optionValue);
    if (!parts.length) {
      const v = this.getCurrentVariant();
      if (v && v.title) parts.push(v.title);
    }
    if (this.state.mode === "subscribe") parts.push("suscripción");
    return parts.join(" · ");
  }

  // Muestra los tipos del tueste activo y devuelve la molienda elegida.
  syncGrind(roast) {
    const box = this.querySelector("[data-grind]");
    if (!box) return null;
    const ground = this.grindMode === "molido";
    let value = null;
    box.querySelectorAll("[data-grind-types]").forEach((group) => {
      const active = ground && group.dataset.grindTypes === roast;
      group.hidden = !active;
      if (active) {
        const sel =
          group.querySelector("[data-grind-type].is-selected") ||
          group.querySelector("[data-grind-type]");
        if (sel) value = sel.dataset.grindType;
      }
    });
    const input = box.querySelector("[data-grind-input]");
    const whole = input ? input.dataset.whole : "Grano entero";
    const finalValue = ground && value ? value : whole;
    if (input) input.value = finalValue;
    const label = box.querySelector("[data-grind-value]");
    if (label) label.textContent = finalValue;
    return ground && value ? "molido " + value.toLowerCase() : "en grano";
  }

  // La etiqueta de la foto, el panel de explicación, la molienda y la línea
  // de resumen siguen al tueste elegido.
  syncRoast() {
    const roast = this.selectedRoast();
    if (!roast) return;
    const grind = this.syncGrind(roast);
    this.querySelectorAll("[data-roast-tag]").forEach((el) => {
      el.hidden = el.dataset.roastTag !== roast;
    });
    this.querySelectorAll("[data-roast-panel]").forEach((el) => {
      el.hidden = el.dataset.roastPanel !== roast;
    });
    const summary = this.querySelector("[data-atc-summary]");
    if (summary) {
      const fmtSel = this.querySelector("[data-format-group] .is-selected");
      const parts = [summary.dataset.productTitle, "tueste " + roast];
      if (grind) parts.push(grind);
      if (fmtSel) parts.push(fmtSel.dataset.optionValue);
      summary.textContent = parts.join(" · ");
    }
  }

  // Cada tarjeta de formato enseña el precio de la variante que se compraría
  // con ese formato y el resto de opciones como están ahora, y su €/kg.
  syncFormatPrices(selectedOptions) {
    const group = this.querySelector("[data-format-group]");
    if (!group) return;
    const idx = parseInt(group.dataset.optionIndex, 10);
    const variants = this.getVariants();
    group.querySelectorAll("[data-variant-pill]").forEach((card) => {
      const wanted = selectedOptions.slice();
      wanted[idx] = card.dataset.optionValue;
      const v = variants.find((x) =>
        x.options.every((o, i) => wanted[i] == null || wanted[i] === o)
      );
      card.classList.toggle("is-soldout", !v || !v.available);
      if (!v) return;
      const priceEl = card.querySelector("[data-fmt-price]");
      if (priceEl) priceEl.textContent = this.formatPrice(v.price / 100);
      const kiloEl = card.querySelector("[data-fmt-kilo]");
      const grams = parseFloat(card.dataset.grams || "0");
      if (kiloEl && grams > 0)
        kiloEl.textContent = this.formatPrice(v.price / 100 * (1000 / grams));
    });
  }

  syncPlansForVariant(variant) {
    const allocs = variant.selling_plan_allocations || [];
    const pills = this.querySelectorAll("[data-freq]");
    if (!pills.length) return;
    pills.forEach((pill) => {
      const planId = pill.dataset.planId;
      const alloc = allocs.find(
        (a) =>
          String(a.selling_plan_id || (a.selling_plan && a.selling_plan.id)) ===
          String(planId)
      );
      if (alloc) {
        pill.dataset.planPrice = alloc.price;
        pill.dataset.planCompare = alloc.compare_at_price || variant.price;
        pill.style.display = "";
      } else {
        pill.style.display = "none";
      }
    });
    // Update activePlanPrice from active pill (or first visible)
    const activePill =
      this.querySelector("[data-freq].is-selected:not([style*='display: none'])") ||
      this.querySelector("[data-freq]:not([style*='display: none'])");
    if (activePill) {
      this.state.activePlanId = activePill.dataset.planId || "";
      this.state.activePlanPrice =
        parseFloat(activePill.dataset.planPrice || "0") / 100;
      pills.forEach((p) =>
        p.classList.toggle("is-selected", p === activePill)
      );
    }
  }

  bindMode() {
    this.querySelectorAll("[data-mode]").forEach((card) => {
      card.addEventListener("click", () => {
        this.state.mode = card.dataset.mode;
        this.querySelectorAll("[data-mode]").forEach((c) =>
          c.classList.toggle("is-active", c.dataset.mode === this.state.mode)
        );
        const subDetails = this.querySelector("[data-sub-details]");
        if (subDetails)
          subDetails.style.display =
            this.state.mode === "subscribe" ? "" : "none";
        const stepperEl = this.querySelector("[data-stepper]");
        if (stepperEl)
          stepperEl.style.display = this.state.mode === "subscribe" ? "none" : "";
        this.syncSellingPlanInput();
        this.render();
      });
    });
  }

  bindFreq() {
    this.querySelectorAll("[data-freq]").forEach((p) => {
      p.addEventListener("click", () => {
        this.state.activePlanId = p.dataset.planId || "";
        this.state.activePlanPrice =
          parseFloat(p.dataset.planPrice || "0") / 100;
        this.querySelectorAll("[data-freq]").forEach((x) =>
          x.classList.toggle("is-selected", x === p)
        );
        // Sync summary freq label
        const summaryFreq = this.querySelector("[data-summary-freq]");
        if (summaryFreq) summaryFreq.textContent = p.textContent.trim().toLowerCase();
        this.syncSellingPlanInput();
        this.render();
      });
    });
    this.querySelectorAll("[data-subqty]").forEach((p) => {
      p.addEventListener("click", () => {
        this.state.subQty = parseInt(p.dataset.subqty, 10);
        this.querySelectorAll("[data-subqty]").forEach((x) =>
          x.classList.toggle(
            "is-selected",
            parseInt(x.dataset.subqty, 10) === this.state.subQty
          )
        );
        this.render();
      });
    });
  }

  syncSellingPlanInput() {
    const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) return;
    sellingPlanInput.value =
      this.state.mode === "subscribe" ? this.state.activePlanId : "";
  }

  bindStepper() {
    const minus = this.querySelector("[data-qty-minus]");
    const plus = this.querySelector("[data-qty-plus]");
    const qtyDisplay = this.querySelector("[data-qty-display]");
    const qtyInput = this.querySelector('input[name="quantity"]');
    if (minus)
      minus.addEventListener("click", () => {
        this.state.qty = Math.max(1, this.state.qty - 1);
        if (qtyDisplay) qtyDisplay.textContent = this.state.qty;
        if (qtyInput) qtyInput.value = this.state.qty;
        this.render();
      });
    if (plus)
      plus.addEventListener("click", () => {
        this.state.qty = Math.min(99, this.state.qty + 1);
        if (qtyDisplay) qtyDisplay.textContent = this.state.qty;
        if (qtyInput) qtyInput.value = this.state.qty;
        this.render();
      });
  }

  bindForm() {
    const form = this.querySelector("form[data-pdp-form]");
    if (!form) return;
    // Red de seguridad en fase de captura: <product-form> escucha el submit en
    // el propio form, así que hay que cortar el evento antes de que llegue ahí
    // si la variante no tiene stock (Shopify devolvería un 422).
    this.addEventListener(
      "submit",
      (e) => {
        const variant = this.getCurrentVariant();
        if (variant && variant.available) return;
        e.preventDefault();
        e.stopPropagation();
        this.updateAvailability();
      },
      true
    );
    form.addEventListener("submit", () => {
      const qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) {
        qtyInput.value =
          this.state.mode === "subscribe" ? this.state.subQty : this.state.qty;
      }
      this.syncSellingPlanInput();
    });
  }

  formatPrice(n) {
    return this.currencySymbol + n.toFixed(2).replace(".", ",");
  }

  render() {
    const isSub = this.state.mode === "subscribe";
    const unit = isSub && this.state.activePlanPrice > 0
      ? this.state.activePlanPrice
      : this.basePrice;
    const total = unit * (isSub ? this.state.subQty : this.state.qty);
    const save = isSub ? (this.basePrice - unit) * this.state.subQty : 0;

    const priceEl = this.querySelector("[data-current-price]");
    if (priceEl) priceEl.textContent = this.formatPrice(unit);
    const strikeEl = this.querySelector("[data-strike-price]");
    if (strikeEl) {
      strikeEl.textContent = this.formatPrice(this.basePrice);
      strikeEl.style.display = isSub && this.basePrice > unit ? "" : "none";
    }
    const atcLabel = this.querySelector("[data-atc-label]");
    if (atcLabel) atcLabel.textContent = this.atcLabelText();
    const atcPrice = this.querySelector("[data-atc-price]");
    if (atcPrice) atcPrice.textContent = this.formatPrice(total);
    const atcSuffix = this.querySelector("[data-atc-suffix]");
    if (atcSuffix) atcSuffix.style.display = isSub ? "" : "none";

    const summaryQty = this.querySelector("[data-summary-qty]");
    if (summaryQty) summaryQty.textContent = this.state.subQty;
    const summarySave = this.querySelector("[data-summary-save]");
    if (summarySave && save > 0) summarySave.textContent = this.formatPrice(save);

    const modeCardSubPrice = this.querySelector("[data-sub-card-price]");
    if (modeCardSubPrice && this.state.activePlanPrice > 0)
      modeCardSubPrice.textContent = this.formatPrice(this.state.activePlanPrice);
    const modeCardSubStrike = this.querySelector("[data-sub-card-strike]");
    if (modeCardSubStrike)
      modeCardSubStrike.textContent = this.formatPrice(this.basePrice);
    const modeCardSubSave = this.querySelector("[data-sub-card-save]");
    if (modeCardSubSave) {
      const planSave = this.basePrice - this.state.activePlanPrice;
      modeCardSubSave.textContent = this.formatPrice(planSave > 0 ? planSave : 0);
    }
    const modeCardBadge = this.querySelector("[data-sub-card-badge]");
    if (modeCardBadge && this.basePrice > 0) {
      const pct = Math.round(
        ((this.basePrice - this.state.activePlanPrice) / this.basePrice) * 100
      );
      if (pct > 0) modeCardBadge.textContent = "-" + pct + "%";
      else modeCardBadge.style.display = "none";
    }
    const oneTimeCardPrice = this.querySelector("[data-one-card-price]");
    if (oneTimeCardPrice)
      oneTimeCardPrice.textContent = this.formatPrice(this.basePrice);

    // Hoja y barra flotante: mismo precio y misma etiqueta que el botón.
    const sheetPrice = this.querySelector("[data-buysheet-price]");
    if (sheetPrice) sheetPrice.textContent = this.formatPrice(total);
    const sheetLabel = this.querySelector("[data-buysheet-label]");
    if (sheetLabel) sheetLabel.textContent = this.atcLabelText();
    const stickyPrice = document.querySelector("[data-sticky-price]");
    if (stickyPrice) stickyPrice.textContent = this.formatPrice(total);
    const stickySummary = document.querySelector("[data-sticky-summary]");
    if (stickySummary) stickySummary.textContent = this.stickySummaryText();
  }
}

if (!customElements.get("pdp-main")) {
  customElements.define("pdp-main", PdpMain);
}

// Sticky add bar visibility
class PdpStickyBar extends HTMLElement {
  constructor() {
    super();
    this.bottomBuffer = 360;
  }
  connectedCallback() {
    // Visible siempre que el botón de añadir de la página no esté en pantalla:
    // así nunca hay que hacer scroll para encontrarlo.
    this.atc = document.querySelector("pdp-main .atc");
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });
    const open = this.querySelector("[data-sticky-open]");
    if (open)
      open.addEventListener("click", () => {
        const main = document.querySelector("pdp-main");
        if (main && typeof main.openSheet === "function") main.openSheet();
      });
    this.onScroll();
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
  }
  onScroll() {
    if (this.raf) return;
    this.raf = requestAnimationFrame(() => {
      this.raf = null;
      let atcInView = false;
      if (this.atc) {
        const r = this.atc.getBoundingClientRect();
        atcInView = r.bottom > 0 && r.top < window.innerHeight;
      }
      const max =
        document.body.scrollHeight - window.innerHeight - this.bottomBuffer;
      this.classList.toggle("is-hidden", atcInView || window.scrollY >= max);
    });
  }
}
if (!customElements.get("pdp-sticky-bar")) {
  customElements.define("pdp-sticky-bar", PdpStickyBar);
}
